export default __webpack_public_path__ + "static/media/portfolio-smiles-2.cfd78474.jpg";